"use client";
import React from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

interface CustomDatePickerProps {
  value?: Date | string | DateObject | null;
  onChange?: (value: any) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: string | null;
  hasShadow?: boolean;
  format?: string;
  inputClassName?: string;
  containerClassName?: string;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  value,
  onChange,
  placeholder = "یک تاریخ انتخاب کنید",
  disabled = false,
  error = null,
  hasShadow = false,
  format = "YYYY/MM/DD",
  inputClassName,
  containerClassName,
}) => {
  const t = useTranslations();
  return (
    <>
      <DatePicker
        format={format}
        name="custom-persian-datepicker"
        calendar={persian}
        locale={persian_fa}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        containerClassName={containerClassName}
        inputClass={cn(
          "h-8 w-full shrink-0 grow rounded-xl bg-white! px-4 text-gray-900 transition lg:h-10 xl:h-12 custom-persian-datepicker-input",
          hasShadow
            ? "focus:shadow-main-primary! focus:border-primary-main! hover:border-primary-main! hover:shadow-main-primary! border! border-gray-300! shadow-main"
            : "",
          disabled ? "cursor-not-allowed bg-gray-100" : "",
          error
            ? "border-error-main! focus:border-error-main! bg-error-light"
            : "",
          inputClassName,
        )}
      />
      {typeof error === "string" && (
        <p className="text-error-main text-xs">{t(error as any)}</p>
      )}
    </>
  );
};

export default CustomDatePicker;
